import netsLogout from './nets-logout';
import moduleConfig from './module-config';

export default angular
  .module('app.logout', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsLogout', netsLogout);
